<div class="modal-backdrop" (click)="onBackdropClick($event)">
  <div class="modal-container">

    <header class="modal-header">
      <div class="modal-header__title">
        <ion-icon name="document-text-outline" class="modal-header__icon"></ion-icon>
        <h2>{{ 'CHANGELOG.MODAL.TITLE' | translate }}</h2>
      </div>
      <button class="modal-header__close" (click)="close()" [attr.aria-label]="'CHANGELOG.MODAL.CLOSE' | translate">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </header>

    <div class="modal-toolbar">
      <div class="toolbar-search">
        <ion-icon name="search-outline" class="toolbar-search__icon"></ion-icon>
        <input
          type="text"
          class="toolbar-search__input"
          [placeholder]="'CHANGELOG.MODAL.SEARCH_PLACEHOLDER' | translate"
          [value]="searchQuery"
          (input)="onSearchInput($any($event.target).value)"
        />
        <button
          *ngIf="searchQuery"
          class="toolbar-search__clear"
          (click)="onSearchInput('')">
          <ion-icon name="close-circle"></ion-icon>
        </button>
      </div>

      <div class="toolbar-filters">
        <select
          class="toolbar-filters__select"
          [ngModel]="selectedCategory"
          (ngModelChange)="onCategoryChange($event)">
          <option [ngValue]="null">{{ 'CHANGELOG.MODAL.ALL_CATEGORIES' | translate }}</option>
          <option *ngFor="let cat of availableCategories" [ngValue]="cat">
            {{ cat }}
          </option>
        </select>

        <button
          *ngIf="hasActiveFilters"
          class="toolbar-filters__clear"
          (click)="clearFilters()">
          <ion-icon name="refresh-outline"></ion-icon>
          {{ 'CHANGELOG.MODAL.CLEAR_FILTERS' | translate }}
        </button>
      </div>
    </div>

    <div class="modal-body">

      <div *ngIf="status() === 'loading'" class="state-loading">
        <ion-spinner name="crescent"></ion-spinner>
        <p>{{ 'CHANGELOG.MODAL.LOADING' | translate }}</p>
      </div>

      <div *ngIf="status() === 'error'" class="state-error">
        <ion-icon name="alert-circle-outline" class="state-error__icon"></ion-icon>
        <p>{{ error() }}</p>
        <button class="btn-retry" (click)="retry()">{{ 'CHANGELOG.MODAL.ERROR_RETRY' | translate }}</button>
      </div>

      <div *ngIf="status() === 'success' && filteredVersions().length === 0" class="state-empty">
        <ion-icon name="search-outline" class="state-empty__icon"></ion-icon>
        <p>{{ 'CHANGELOG.MODAL.EMPTY_RESULTS' | translate }}</p>
        <button *ngIf="hasActiveFilters" class="btn-retry" (click)="clearFilters()">
          {{ 'CHANGELOG.MODAL.CLEAR_FILTERS_BTN' | translate }}
        </button>
      </div>

      <cdk-virtual-scroll-viewport
        *ngIf="status() === 'success' && filteredVersions().length > 0 && useVirtualScroll"
        itemSize="180"
        class="timeline timeline--virtual">

        <div
          *cdkVirtualFor="let version of filteredVersions(); trackBy: trackByVersion"
          class="timeline-item"
          [class.timeline-item--latest]="isLatest(version)">

          <div class="timeline-item__connector">
            <div class="timeline-item__dot" [class.timeline-item__dot--latest]="isLatest(version)"></div>
            <div class="timeline-item__line" *ngIf="!isLast(version)"></div>
          </div>

          <ng-container *ngTemplateOutlet="versionContent; context: { $implicit: version }"></ng-container>
        </div>
      </cdk-virtual-scroll-viewport>

      <div
        *ngIf="status() === 'success' && filteredVersions().length > 0 && !useVirtualScroll"
        class="timeline">

        <div
          *ngFor="let version of filteredVersions(); let first = first; let last = last; trackBy: trackByVersion"
          class="timeline-item"
          [class.timeline-item--latest]="first">

          <div class="timeline-item__connector">
            <div class="timeline-item__dot" [class.timeline-item__dot--latest]="first"></div>
            <div class="timeline-item__line" *ngIf="!last"></div>
          </div>

          <ng-container *ngTemplateOutlet="versionContent; context: { $implicit: version }"></ng-container>
        </div>
      </div>

    </div>

    <footer class="modal-footer">
      <span class="modal-footer__info">
        {{ filteredVersions().length }} {{ 'CHANGELOG.MODAL.VERSIONS_COUNT' | translate }}
        <span *ngIf="hasActiveFilters"> {{ 'CHANGELOG.MODAL.FILTERED' | translate }}</span>
      </span>
      <button class="modal-footer__close" (click)="close()">{{ 'CHANGELOG.MODAL.CLOSE' | translate }}</button>
    </footer>

  </div>
</div>

<ng-template #versionContent let-version>
  <div class="timeline-item__content">

    <div class="timeline-item__header">
      <div class="timeline-item__version">
        <span class="version-tag" [class.version-tag--latest]="isLatest(version)">
          v{{ version.version }}
        </span>
        <span class="version-badge" *ngIf="isLatest(version)">{{ 'CHANGELOG.MODAL.VERSION_LATEST' | translate }}</span>
      </div>
      <span class="timeline-item__date" *ngIf="version.date">
        {{ version.date }}
      </span>
    </div>

    <div
      *ngFor="let category of getCategories(version)"
      class="timeline-category">
      <div class="timeline-category__header">
        <ion-icon
          [name]="getCategoryIcon(category)"
          [style.color]="getCategoryColor(category)">
        </ion-icon>
        <span
          class="timeline-category__badge"
          [style.background-color]="getCategoryColor(category)">
          {{ category }}
        </span>
        <span class="timeline-category__count">
          {{ version.categories[category].length }}
        </span>
      </div>
      <ul class="timeline-category__list">
        <li *ngFor="let entry of version.categories[category]">
          {{ entry }}
        </li>
      </ul>
    </div>

    <div class="timeline-item__summary">
      {{ getTotalChanges(version) }} {{ 'CHANGELOG.MODAL.CHANGES_IN_CATEGORIES' | translate }} {{ getCategories(version).length }} {{ 'CHANGELOG.MODAL.CATEGORIES_LABEL' | translate }}
    </div>
  </div>
</ng-template>
